import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import BillingSummaryGrid from './BillingSummaryGrid';
import Loader from '../../../common/Loader';
import { clearBillingReport } from '../../../../actions';

export const BillingSearchResult = ({
  dispatchClearBillingReport,
  billings,
  loading,
}) => {
  useLayoutEffect(() => () => dispatchClearBillingReport(), []);
  if (loading) return <Loader />;

  const rows = billings.get('rows') || [];
  const electronicTotal = billings.get('electronicTotal');

  return (
    <div className="mt-3">
      <BillingSummaryGrid rows={rows} electronicTotal={electronicTotal} />
    </div>
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: AccountingUnit.Billing.getIn(['report', 'loading']),
  billings: AccountingUnit.Billing.getIn(['report', 'content']),
});

BillingSearchResult.propTypes = {
  billings: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchClearBillingReport: PropTypes.func.isRequired,
};

BillingSearchResult.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchClearBillingReport: clearBillingReport,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingSearchResult);
